type keys = "accessToken" | "menuLinks";

const localStorageHelper = {
   get: (key: keys) => localStorage.getItem(key) || null,
   set: (key: keys, value: string) => localStorage.setItem(key, value),
   remove: (key: keys) => localStorage.removeItem(key),
};

export { localStorageHelper };
